import classNames from "classnames";
import { HTMLAttributes } from "react";
import * as React from "react";
import * as styles from "./Input.less";

export const InputWrapper = React.forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
        <div {...props} className={classNames(styles.input_wrapper, className)} ref={ref} />
    )
);
